import { FC, useState } from "react";
import cx from "classnames";
import CollapsibleItem, { CollapsibleItemProps } from "./CollapsibleItem";

interface CollapsibleListProps {
  data: CollapsibleItemProps[];
  itemClassName?: string;
}

const CollapsibleList: FC<CollapsibleListProps> = ({ data, itemClassName }) => {
  const [openItemId, setOpenItemId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenItemId((prevId) => (prevId === id ? null : id));
  };

  return (
    <>
      {data.map(({ id, label, description }, idx) => (
        <CollapsibleItem
          key={id}
          id={id}
          className={cx(idx !== 0 && "mt-[6px] md:mt-[8px]")}
          label={label}
          description={description}
          itemClassName={itemClassName}
          isOpen={id === openItemId}
          isLast={idx === data.length - 1}
          onToggle={() => handleToggle(id!)} // assume id is always defined
        />
      ))}
    </>
  );
};

export default CollapsibleList;
